import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

interface IModalPrexistenceProps {
  open: boolean;
  toggle: any;
}

export default function ModalPreexistence(props: IModalPrexistenceProps) {
  const { open, toggle } = props;

  return (
    <Modal isOpen={open} modalClassName="format-new-modal-2" size="lg">
      <ModalBody>
        <div className="w-100">
          <div className="d-flex justify-content-end align-content-center align-items-center">
            <img 
              src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Action%20Group.svg"
              className="cursor-pointer"
              alt=""
              onClick={toggle(false)}
            />
          </div>
          <div className="modal-body-content px-14">
            <h4 className="px-20">Estado de Salud</h4>
            <p>Debido a que tu grupo familiar ha tenido o tiene alguna de estas enfermedades, nuestros ejecutivos te contactarán para continuar con tu contratación de forma personal.</p>
            <p>También puedes:</p>
            <ul>
              <li>Llamar al <a href="tel:800380800">800 380 800</a> de lunes a viernes de 09:00 a 20:00 hrs.</li>
              <li>Escribirnos por <a target="_blank" rel="noreferrer" href="https://wa.me/56223906570">WhatsApp</a>. Atención de lunes a viernes de 09:00 a 18:30 hrs.</li>
              <li>Acércarte a una de nuestras <a target="_blank" rel="noreferrer" href="https://web.segurosfalabella.com/cl/sucursales/">sucursales</a>.</li>
            </ul>
            <p>Al contactarnos, nuestros ejecutivos te preguntarán por las enfermedades que tu grupo familiar ha tenido o tiene, por lo que te sugerimos revisar los ejemplos.</p>
            <div className="d-flex justify-content-center align-items-center align-content-center">
              <img src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Group.svg" alt=""/>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="modal-footer col-12 col-sm-10 col-lg-8 mx-auto mt-19">
        <button
          className="btn primary go-to-product-description px-26"
          onClick={toggle(false)}
        >
          Entiendo
        </button>
      </ModalFooter>
    </Modal>
  );
}
